
import VueJSModal from 'vue-js-modal'
import { Vue, Component, Prop } from 'vue-property-decorator'
import eventBus from '../../plugins/eventBus'
import { envConfiguration } from '@/plugins/globalStaticDatas'
Vue.use(VueJSModal)

@Component({})
export default class MenuModal extends Vue {
  product: Object = {}
  envConfigurations: object = envConfiguration

  mounted() {
    eventBus.$on('daily-menu:details', (product: Object) => {
      this.product = product
    })
  }
}
